import { ref } from "vue";

const orderDiscountCode = ref(undefined);
const captchaToken = ref(undefined);
export const useOrderDiscountStore = () => {
  return { orderDiscountCode, captchaToken };
};
